import React from 'react';
import type { ReactElement } from 'react';
import Card from 'atom-components/card';
import StatusSelect from './status-select';

type Props = {
  canAdministrateMark: boolean;
};

export default function MarkAdministration({ canAdministrateMark }: Props): ReactElement {
  return (
    <Card>
      <Card.Header>
        <Card.Heading level={3}>Mark Administration</Card.Heading>
      </Card.Header>
      <Card.Body>
        <p>
          Marking admins can change the status of the mark manually. You{' '}
          {!canAdministrateMark && "don't"} have the ability to do this.
        </p>
        <StatusSelect canAdministrateMark={canAdministrateMark} />
      </Card.Body>
    </Card>
  );
}
